/* src/app/pages/auth/signin/component.scss */
.linkAriadne {
  font-size: 18px;
  float: right;
  color: black;
}
.linkAriadne:hover {
  color: red;
}
.imgAriadne {
  height: 60px !important;
}
.inputSignin {
  border-top: none;
  border-left: none;
  border-right: none;
  float: left;
}
.floatLeft {
  float: left;
}
.responsive {
  width: 100px;
  max-width: 100%;
  height: auto;
}
.error {
  font-size: 12px;
}
/*# sourceMappingURL=component.css.map */
